<div class="notification-empty">
  <span class="notification-empty__icon" aria-hidden="true">🔔</span>
  <strong class="notification-empty__title">{{ title }}</strong>
  <p class="notification-empty__description">{{ description }}</p>
</div>
